import { createReducer } from 'reduxsauce';
import { createSelector } from 'reselect';
import Immutable from 'seamless-immutable';
import { SignupTypes } from '../actions/SignupActions';
import { isValidEmail, isEmpty } from '../../services/Validation';

/* ------------- Initial Signup State ------------- */
export const INITIAL_STATE = Immutable({
  error: '',
  signingUp: false,
  email: '',
  showEmailError: false,
  password: '',
  showPasswordError: false,
  confirmEmail: '',
  showConfirmEmailError: false,
  confirmPassword: '',
  showConfirmPasswordError: false,
  canSignup: false,
  signedUp: false,
});

/* ------------- Reducers ------------- */
export const onSignupRequest = (state) => state.merge({ signingUp: true });
export const onSignupSuccess = (state) =>
  state.merge({ signingUp: false, signedUp: true });
export const onSignupFailure = (state, { error }) =>
  state.merge({ signingUp: false, error });
export const onEmailChange = (state, { email }) =>
  state.merge({ email, showEmailError: true });
export const onPasswordChange = (state, { password }) =>
  state.merge({ password, showPasswordError: true });
export const onConfirmEmailChange = (state, { confirmEmail }) =>
  state.merge({ confirmEmail, showConfirmEmailError: true });
export const onConfirmPasswordChange = (state, { confirmPassword }) =>
  state.merge({ confirmPassword, showConfirmPasswordError: true });
export const onClearSignupError = (state) => state.merge({ error: '' });

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [SignupTypes.SIGNUP_REQUEST]: onSignupRequest,
  [SignupTypes.SIGNUP_SUCCESS]: onSignupSuccess,
  [SignupTypes.SIGNUP_FAILURE]: onSignupFailure,
  [SignupTypes.EMAIL_CHANGED]: onEmailChange,
  [SignupTypes.CONFIRM_EMAIL_CHANGED]: onConfirmEmailChange,
  [SignupTypes.PASSWORD_CHANGED]: onPasswordChange,
  [SignupTypes.CONFIRM_PASSWORD_CHANGED]: onConfirmPasswordChange,
  [SignupTypes.CLEAR_SIGNUP_ERROR]: onClearSignupError,
});

/* ------------- Selectors ------------- */
export const isSigningUp = (state) => state.signup.signingUp;
export const isSignedUp = (state) => state.signup.signedUp;
export const getError = (state) => state.signup.error;
export const getEmail = (state) => state.signup.email;
export const getPassword = (state) => state.signup.password;
export const getConfirmEmail = (state) => state.signup.confirmEmail;
export const getConfirmPassword = (state) => state.signup.confirmPassword;
export const shouldShowEmailError = (state) => state.signup.showEmailError;
export const shouldShowPasswordError = (state) =>
  state.signup.showPasswordError;
export const shouldShowConfirmEmailError = (state) =>
  state.signup.showConfirmEmailError;
export const shouldShowConfirmPasswordError = (state) =>
  state.signup.showConfirmPasswordError;

// memoized
export const getEmailError = createSelector(getEmail, (email) =>
  isValidEmail(email) ? '' : 'A valid email address is required'
);
export const getPasswordError = createSelector(getPassword, (password) =>
  isEmpty(password) ? 'Password is required' : ''
);
export const getConfirmEmailError = createSelector(
  [getConfirmEmail, getEmail],
  (confirmEmail, email) => {
    if (!isValidEmail(confirmEmail)) return 'A valid email address is required';
    if (email !== confirmEmail) return 'Emails must match';
    return '';
  }
);
export const getConfirmPasswordError = createSelector(
  [getConfirmPassword, getPassword],
  (confirmPassword, password) => {
    if (isEmpty(confirmPassword)) return 'Confirmation password is required';
    if (password !== confirmPassword) return 'Passwords must match';
    return '';
  }
);
export const canSignup = createSelector(
  [getConfirmEmailError, getConfirmPasswordError],
  (emailError, passwordError) =>
    emailError.length === 0 && passwordError.length === 0
);



// WEBPACK FOOTER //
// ./src/state/reducers/SignupReducer.js